import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaBookOpenReader } from "react-icons/fa6";
import BrowseTrainings from "./index";
import { MODULE_BROWSE_TRAINING } from "variables/constants";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";

const browseTrainingRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Browse Training",
		basePath: "browse-trainings",
		mainComponent: <BrowseTrainings />,
	    layout: "/console",	   
	    icon: <FaBookOpenReader className="icon-item" />,
	    subTitle:"Browse Trainings",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: MODULE_BROWSE_TRAINING,
	})
]

export default browseTrainingRoutes;